module.exports = "<p *ngIf=\"text\" style=\"color: #000\" class=\"inner\" [innerHTML]=\"html | routerLink | replaceBadwords | async\">\r\n</p>\r\n<span *ngIf=\"isCollapsable\" class=\"textExposedHide\">{{textExposedHide}}</span>\r\n<a class=\"see-more-text\" *ngIf=\"isCollapsable\" href='javascript:void(0)' (click)='readMore()'>devamını gör</a>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/post-text/post-text.component.html
// module id = ../../../../../src/app/directive/post-text/post-text.component.html
// module chunks = main